/* eslint-disable @typescript-eslint/ban-types */
import { gql, LazyQueryHookOptions, QueryTuple } from '@apollo/client';

import { useAPILazyQuery } from 'Api/handler';

export type DownloadPDFResponse = {
  downloadPDF: {};
};

export type DownloadPDFVariables = {
  quotationId: number;
};

export const useDownloadPDF = (
  options?: LazyQueryHookOptions<DownloadPDFResponse, DownloadPDFVariables>,
): QueryTuple<DownloadPDFResponse, DownloadPDFVariables> => {
  return useAPILazyQuery(DOWNLOAD_PDF, options);
};

export const DOWNLOAD_PDF = gql`
  query DownloadPDF($quotationId: Float) {
    downloadPDF(quotationId: $quotationId)
  }
`;
